import Dashboard from "views/Dashboard.js";
import UserProfile from "views/UserProfile.js";
import AddFood from "views/AddFood";
import Foods from "views/Foods";
import CategoriesPage from 'views/Categories/CategoriesPage';
import OrdersKanban from 'views/Orders/OrdersKanban';
import AddOrder from 'views/Orders/AddOrder';
import EditOrder from 'views/Orders/EditOrder';
import OrderStatusSettings from 'views/Settings/OrderStatusSettings';
import BusinessHoursSettings from 'views/Settings/BusinessHoursSettings';
import WhatsappConnectionPage from 'views/Settings/WhatsappConnectionPage';
import WhatsappMessagesSettings from 'views/Settings/WhatsappMessagesSettings';
import IntegrationsPage from 'views/Settings/IntegrationsPage';
import DeliverySettings from 'views/Settings/DeliverySettings';
import CouponsSettings from 'views/Settings/CouponsSettings';
import PrintingSettings from 'views/Settings/PrintingSettings';
import TablesPage from 'views/Tables/TablesPage';
import ReportsPage from 'views/Reports/ReportsPage';
import InventoryPage from 'views/Inventory/InventoryPage';
import MirandaReportsPage from 'views/Miranda/MirandaReportsPage';

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "tim-icons icon-chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/pedidos",
    name: "Pedidos",
    icon: "tim-icons icon-paper",
    component: <OrdersKanban />,
    layout: "/admin",
  },
  {
    path: "/cardapio",
    name: "Cardápio",
    icon: "tim-icons icon-notes",
    component: <Foods />,
    layout: "/admin",
  },
  {
    path: "/estoque",
    name: "Estoque",
    icon: "tim-icons icon-basket-simple",
    component: <InventoryPage />,
    layout: "/admin",
    requiresInventory: true,
  },
  {
    path: '/categorias',
    name: 'Categorias',
    icon: 'tim-icons icon-tag',
    component: <CategoriesPage />,
    layout: '/admin',
  },
  {
    path: "/mesas",
    name: "Mesas",
    icon: "tim-icons icon-app",
    component: <TablesPage />,
    layout: "/admin",
    requiresTables: true,
  },
  {
    path: "/relatorios",
    name: "Relatórios",
    icon: "tim-icons icon-chart-bar-32",
    component: <ReportsPage />,
    layout: "/admin",
  },
  {
    path: "/miranda",
    name: "Miranda AI",
    icon: "tim-icons icon-chat-33",
    component: <MirandaReportsPage />,
    layout: "/admin",
    requiresMiranda: true,
  },
  {
    path: "/configuracoes",
    name: "Configurações",
    icon: "tim-icons icon-settings-gear-63",
    layout: "/admin",
    collapse: true,
    state: "configCollapse",
    views: [
      {
        path: "/configuracoes/conta",
        name: "Conta",
        mini: "C",
        component: <UserProfile />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/entrega",
        name: "Entrega",
        mini: "E",
        component: <DeliverySettings />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/conexao",
        name: "WhatsApp",
        mini: "W",
        component: <WhatsappConnectionPage />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/status-pedido",
        name: "Status do pedido",
        mini: "S",
        component: <OrderStatusSettings />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/mensagens",
        name: "Mensagens",
        mini: "M",
        component: <WhatsappMessagesSettings />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/integracoes",
        name: "Integrações",
        mini: "I",
        component: <IntegrationsPage />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/cupons",
        name: "Cupons",
        mini: "U",
        component: <CouponsSettings />,
        layout: "/admin",
      },
      {
        path: "/configuracoes/impressao",
        name: "Impressão",
        mini: "P",
        component: <PrintingSettings />,
        layout: "/admin",
        requiresPrinting: true,
      },
    ],
  },
  {
    path: "/cardapio/adicionar",
    name: "Adicionar item",
    icon: "tim-icons icon-simple-add",
    component: <AddFood />,
    layout: "/admin",
    menu: 0
  },
  {
    path: "/pedidos/novo",
    name: "Novo Pedido",
    icon: "tim-icons icon-simple-add",
    component: <AddOrder />,
    layout: "/admin",
    menu: 0
  },
  {
    path: "/pedidos/editar/:orderId",
    name: "Editar Pedido",
    icon: "tim-icons icon-pencil",
    component: <EditOrder />,
    layout: "/admin",
    menu: 0
  },
  // redirecionamento legado
  {
    path: "/perfil",
    name: "Conta",
    component: <UserProfile />,
    layout: "/admin",
    menu: 0,
  },
  {
    path: "/configuracoes/horario",
    name: "Horário",
    component: <BusinessHoursSettings />,
    layout: "/admin",
    menu: 0,
  },
  {
    path: "/status-pedido",
    name: "Status do pedido",
    component: <OrderStatusSettings />,
    layout: "/admin",
    menu: 0,
  },
];

export default routes;
